export default "__VITE_ASSET__gvKWQ9B5__"